module.exports = __webpack_public_path__ + "img/home-seleccionado.c6e77c75.png";